import {styled} from "@mui/material/styles";
import {Typography} from "@mui/material";

export const StatusTypography = styled(Typography)({
    fontWeight: 'bold',
    paddingTop: '8px',
    paddingBottom: '8px',
});